import React, { useEffect, useRef, useState } from "react";
import { Accordion, Button, Card, Col, Form, Spinner } from "react-bootstrap";
import { nextPointId } from "../../hooks/useCurrentPlan";
import { useUser } from "../../hooks/useUser";
import { maximumDistanceValueOfSaved } from "../../LimitsValue";
import { getPlan } from "./getPlan";
import { kiwiApi } from "./kiwiApi";
import { ModalConfirm } from "./ModalConfirm";
import { ModalAlertChangePlan } from "./plan/ModalAlertChangePlan";
import { ModalAlertDeletePlan } from "./plan/ModalAlertDeletePlan";
import { ModalbtnCopyPlan } from "./plan/ModalbtnCopyPlan";
import { ModalbtnCreateNewPlan } from "./plan/ModalbtnCreateNewPlan";
import { ModalbtnDiscardEditPlan } from "./plan/ModalbtnDiscardEditPlan";
import { sec2hhmm } from "./plan/SearchDirections";
import ExcelJS from 'exceljs';
import iconGoogleMapsLinks from '../../image/icon_Google_Maps_Links.png';
import { TrashIcon } from "./icons";
import { FaCircleInfo } from 'react-icons/fa6';

/**
 * ルートの情報表示、保存、削除をするコンポーネント.
 * ルートの距離制限アラートも出す.
 * modeがfieldTestの場合、Testモード画面用に切り替わる.
 *
 */
export function PlanDetail({
  fleetId,
  vecId,
  plans,
  setPlans,
  route,
  setRoute,
  setName,
  setRouteComment,
  map,
  setGetPlanStatus,
  mode,
  googleMap,
}) {
  const refSelectFleets = useRef(null);
  const plannameRef = useRef(null);
  const planCommnetRef = useRef(null);
  const [alertModalShow, setAlertModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState(null);
  const [confirmMsg, setConfirmMsg] = useState(null);
  const [saveSpinStatus, setSaveSpinStatus] = useState(false);
  const [deleteSpinStatus, setDeleteSpinStatus] = useState(false);
  const [googleMapsLinks, setGoogleMapsLinks] = useState([]);
  const [copiedLinkIndex, setCopiedLinkIndex] = useState(null); // どのリンクがコピーされたかを管理
  //redux導入時にbooleanから複数状態管理（ロード中、成功、失敗etc）に変更する

  const { user } = useUser();

  useEffect(() => {
    if (route === null || route === undefined) {
      return;
    }
    refSelectFleets.current.value = route.plan_id;
    plannameRef.current.value = route.plan_name;
    planCommnetRef.current.value = route.comment ? route.comment : "";

    // pathの更新
    if (map === null) {
      return;
    }
    //PathGeoJson({ route, map });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, map]);

  // ルートのplan_idが変更された時にGoogle Mapリンクをクリア
  useEffect(() => {
    if (route && route.plan_id) {
      // 新しいルートに切り替わった時はリンクをクリア
      setGoogleMapsLinks([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route?.plan_id]);

  // 既存のルート（保存済み）を開いた時にGoogle Mapリンクを自動生成
  useEffect(() => {
    // routeが存在し、pointsがあり、まだリンクが生成されていない場合
    if (route && route.points && route.points.length > 0 && googleMapsLinks.length === 0) {
      try {
        const links = generateGoogleMapsLinks(route);
        if (links.length > 0) {
          setGoogleMapsLinks(links);
        }
      } catch (error) {
        console.error("Error auto-generating Google Maps links:", error);
        // エラーが発生しても既存機能に影響を与えない
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, route?.points]);

  function notChangePlan() {
    setAlertModalShow(false);
    refSelectFleets.current.value = route.plan_id;
    //console.debug("Route Selector", route);
  }
  function changePlan() {
    setAlertModalShow(false);
    //console.log("ルート選択");

    // const routeId = refSelectFleets.current.value;
    const planId = refSelectFleets.current.value;
    // ルート変更時にGoogle Mapリンクをクリア
    setGoogleMapsLinks([]);
    getPlan({ planId, user, nextPointId, setRoute, setGetPlanStatus, map });
  }
  function changeName() {
    setName(plannameRef.current.value);
  }
  function changeComment() {
    setRouteComment(planCommnetRef.current.value);
  }
  function savePlan() {
    console.debug("save plan", route);
    //console.log("save plan", route)
    if (route.distance > maximumDistanceValueOfSaved) {
      // console.log("500km以上です");
      setConfirmModalShow(true);
      setConfirmTitle(`ALERT!  over ${maximumDistanceValueOfSaved / 1000} km`);
      setConfirmMsg(
        `The route over ${
          maximumDistanceValueOfSaved / 1000
        } km can't be saved.Please reduce the distance.`
      );
    } else {
      //routeを保存する
      const planId = route.plan_id;

      setConfirmTitle("SAVE ROUTE");
      setSaveSpinStatus(true);

      kiwiApi(user.token)
        .updatePlan({ planId, updatePlan: route })
        .then((response) => {
          console.debug("updateRoute", response);
          setConfirmModalShow(true);
          setConfirmTitle("SAVE ROUTE");
          setConfirmMsg("The route has been saved successfully!");

          //表示するrouteを変更
          const index = plans.findIndex((route) => route.plan_id === planId);
          plans.splice(index, 1, route);
          setPlans(plans);

          // Google Mapリンクを生成
          try {
            const links = generateGoogleMapsLinks(route);
            setGoogleMapsLinks(links);
          } catch (error) {
            console.error("Error generating Google Maps links:", error);
            // エラーが発生しても既存機能に影響を与えない
          }
        })
        .catch((error) => {
          console.debug("error updateRoute", error);
          setConfirmModalShow(true);
          setConfirmTitle("Failed SAVE ROUTE");
          setConfirmMsg(error.message);
        });
    }
  }
  function cancelDeletePlan() {
    setDeleteModalShow(false);
  }
  function deletePlan() {
    console.debug("delete plan", route.plan_id);
    //route idでdeleteする

    const planId = route.plan_id;

    setDeleteSpinStatus(true);
    setConfirmMsg(null);

    kiwiApi(user.token)
      .deletePlan({ planId })
      .then((response) => {
        console.debug("success deleteRoute", response);
        setDeleteModalShow(false);
        setConfirmModalShow(true);
        setConfirmTitle("SUCCESS! delete route");

        const after = plans.filter((plan) => {
          return plan.plan_id !== planId;
        });
        //console.log(after.length);
        setPlans(after);
        //一番最後のrouteをsetRouteする

        // ルート削除時にGoogle Mapリンクをクリア
        setGoogleMapsLinks([]);

        setConfirmMsg("The route has been deleted successfully!!");
      })
      .catch((error) => {
        console.debug("Error deleteRoute", error);
        setDeleteModalShow(false);
        setConfirmModalShow(true);
        setConfirmTitle("ERROR! delete route");
        setConfirmMsg(error.message);
      });
  }
  function resetPlan() {
    // console.log("ルートリセット");
    //originalルートを取得してsetRouteにする

    const planId = route.plan_id;
    // ルートリセット時にGoogle Mapリンクをクリア
    setGoogleMapsLinks([]);
    getPlan({
      planId,
      user,
      nextPointId,
      setRoute,
      setGetPlanStatus,
      map,
    });
  }

  // Google Mapリンク生成関数
  function generateGoogleMapsLinks(route) {
    try {
      if (!route || !route.points || route.points.length === 0) {
        return [];
      }

      const links = [];
      const MAX_WAYPOINTS = 21; // Google Mapsの制限（開始点 + 20ウェイポイント）
      let currentLink = "https://www.google.com/maps/dir";
      let waypointCount = 0;

      for (let i = 0; i < route.points.length; i++) {
        const point = route.points[i];

        // 緯度経度が有効かチェック
        if (point.lat != null && point.lng != null) {
          const coords = `${point.lat},${point.lng}`;
          currentLink += `/${coords}`;
          waypointCount++;

          // 21個を超えた場合は新しいリンクを作成
          if (waypointCount >= MAX_WAYPOINTS && i < route.points.length - 1) {
            links.push(currentLink);
            // 前のリンクの終点を次のリンクの開始点とする
            currentLink = `https://www.google.com/maps/dir/${coords}`;
            waypointCount = 1; // 終点を開始点として既に1つカウント
          }
        }
      }

      // 最後のリンクを追加
      if (waypointCount > 0) {
        links.push(currentLink);
      }

      return links;
    } catch (error) {
      console.error("Error generating Google Maps links:", error);
      return [];
    }
  }

  // リンクをクリップボードにコピーする関数
  function copyToClipboard(text, index) {
    try {
      navigator.clipboard.writeText(text).then(
        () => {
          setCopiedLinkIndex(index);
          setTimeout(() => setCopiedLinkIndex(null), 2000);
        },
        (err) => {
          console.error("Failed to copy text:", err);
        }
      );
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  }

  // Google MapリンクをCSVとしてダウンロードする関数
  function downloadLinksAsCSV() {
    try {
      if (!googleMapsLinks || googleMapsLinks.length === 0) {
        return;
      }

      // CSVヘッダー
      let csvContent = "Route,Google Maps Link\n";

      // 各リンクをCSV形式で追加
      googleMapsLinks.forEach((link, index) => {
        const routeLabel = googleMapsLinks.length > 1
          ? `Route ${index + 1} of ${googleMapsLinks.length}`
          : "Route";
        // CSVではダブルクォートで囲む（カンマやダブルクォートが含まれる場合に対応）
        csvContent += `"${routeLabel}","${link}"\n`;
      });

      // BOMを追加（ExcelでUTF-8を正しく認識させるため）
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
      const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });

      // ダウンロード用のリンクを作成
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // ファイル名を生成（ルート名 + 日時）
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = route && route.plan_name
        ? `${route.plan_name}_GoogleMapsLinks_${timestamp}.csv`
        : `GoogleMapsLinks_${timestamp}.csv`;

      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // メモリ解放
      URL.revokeObjectURL(url);

      console.log('CSV download completed');
    } catch (error) {
      console.error("Error downloading CSV:", error);
      // エラーが発生しても既存機能に影響を与えない
    }
  }

  // Google MapリンクをExcelとしてダウンロードする関数（ExcelJS使用）
  async function downloadLinksAsExcel() {
    try {
      if (!googleMapsLinks || googleMapsLinks.length === 0) {
        return;
      }

      // ExcelJSワークブックを作成
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Google Maps Links');

      // ヘッダー行を追加
      worksheet.columns = [
        { header: 'Route', key: 'route', width: 20 },
        { header: 'Google Maps Link', key: 'link', width: 100 }
      ];

      // ヘッダー行のスタイル設定
      worksheet.getRow(1).font = { bold: true };

      // 各リンクを行として追加
      googleMapsLinks.forEach((link, index) => {
        const routeLabel = googleMapsLinks.length > 1
          ? `Route ${index + 1} of ${googleMapsLinks.length}`
          : "Route";

        const row = worksheet.addRow({
          route: routeLabel,
          link: link
        });

        // リンクセル（B列）にハイパーリンクとスタイルを設定
        const linkCell = row.getCell(2);

        // ハイパーリンクを設定
        linkCell.value = {
          text: link,
          hyperlink: link,
          tooltip: 'Click to open in Google Maps'
        };

        // スタイルを設定（青色、下線付き）
        linkCell.font = {
          color: { argb: 'FF0563C1' }, // Excel標準のハイパーリンクブルー
          underline: true,
          name: 'Calibri',
          size: 11
        };

        linkCell.alignment = {
          vertical: 'top',
          horizontal: 'left'
        };
      });

      // ファイル名を生成（ルート名 + 日時）
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = route && route.plan_name
        ? `${route.plan_name}_GoogleMapsLinks_${timestamp}.xlsx`
        : `GoogleMapsLinks_${timestamp}.xlsx`;

      // Excelファイルをバッファとして生成
      const buffer = await workbook.xlsx.writeBuffer();

      // Blobを作成してダウンロード
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // ダウンロード用のリンクを作成
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // メモリ解放
      URL.revokeObjectURL(url);

      console.log('Excel download completed');
    } catch (error) {
      console.error("Error downloading Excel:", error);
      // エラーが発生しても既存機能に影響を与えない
    }
  }

  // XML特殊文字をエスケープする関数
  function escapeXml(unsafe) {
    if (!unsafe) return '';
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  // ルートデータをKMLとしてダウンロードする関数
  function downloadRouteAsKML() {
    try {
      if (!route) {
        return;
      }

      // ルート検索結果（path_geojson）が存在するか確認
      if (!route.path_geojson || !route.path_geojson.geometry || !route.path_geojson.geometry.coordinates) {
        console.warn('Route path data (path_geojson) not found. Please search route first.');
        setConfirmModalShow(true);
        setConfirmTitle('Route Path Not Found');
        setConfirmMsg('Please search the route first before downloading KML.');
        return;
      }

      const coordinates = route.path_geojson.geometry.coordinates;
      if (coordinates.length === 0) {
        return;
      }

      // KMLヘッダー
      let kmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n';
      kmlContent += '<kml xmlns="http://www.opengis.net/kml/2.2">\n';
      kmlContent += '  <Document>\n';
      kmlContent += `    <name>${escapeXml(route.plan_name || 'Route')}</name>\n`;
      kmlContent += '    <description>Route path exported from Route Plan</description>\n';

      // 経路用のスタイル
      kmlContent += '    <Style id="routeStyle">\n';
      kmlContent += '      <LineStyle>\n';
      kmlContent += '        <color>ff0000ff</color>\n'; // 赤色
      kmlContent += '        <width>3</width>\n';
      kmlContent += '      </LineStyle>\n';
      kmlContent += '    </Style>\n';

      // 経由地ピン用のスタイル
      kmlContent += '    <Style id="waypointStyle">\n';
      kmlContent += '      <IconStyle>\n';
      kmlContent += '        <color>ff00ff00</color>\n'; // 緑色
      kmlContent += '        <scale>1.0</scale>\n';
      kmlContent += '        <Icon>\n';
      kmlContent += '          <href>http://maps.google.com/mapfiles/kml/paddle/grn-circle.png</href>\n';
      kmlContent += '        </Icon>\n';
      kmlContent += '      </IconStyle>\n';
      kmlContent += '    </Style>\n';

      // 経路（LineString）
      kmlContent += '    <Placemark>\n';
      kmlContent += `      <name>${escapeXml(route.plan_name || 'Route')} Path</name>\n`;
      kmlContent += '      <styleUrl>#routeStyle</styleUrl>\n';
      kmlContent += '      <LineString>\n';
      kmlContent += '        <tessellate>1</tessellate>\n';
      kmlContent += '        <coordinates>\n';

      // GeoJSONの座標データを追加（GeoJSON: [lng, lat], KML: 経度,緯度,高度）
      coordinates.forEach(coord => {
        const lng = coord[0];
        const lat = coord[1];
        kmlContent += `          ${lng},${lat},0\n`;
      });

      kmlContent += '        </coordinates>\n';
      kmlContent += '      </LineString>\n';
      kmlContent += '    </Placemark>\n';

      // 経由地のピンを追加
      if (route.points && route.points.length > 0) {
        route.points.forEach((point, index) => {
          if (point.lat != null && point.lng != null) {
            const pointName = point.name || `Waypoint ${index + 1}`;
            const pointComment = point.comment || '';
            kmlContent += '    <Placemark>\n';
            kmlContent += `      <name>${escapeXml(pointName)}</name>\n`;
            kmlContent += `      <description>${escapeXml(pointComment)}</description>\n`;
            kmlContent += '      <styleUrl>#waypointStyle</styleUrl>\n';
            kmlContent += '      <Point>\n';
            kmlContent += `        <coordinates>${point.lng},${point.lat},0</coordinates>\n`;
            kmlContent += '      </Point>\n';
            kmlContent += '    </Placemark>\n';
          }
        });
      }

      // KMLフッター
      kmlContent += '  </Document>\n';
      kmlContent += '</kml>';

      // BOMを追加
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
      const blob = new Blob([bom, kmlContent], { type: 'application/vnd.google-earth.kml+xml;charset=utf-8;' });

      // ダウンロード用のリンクを作成
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // ファイル名を生成（ルート名 + 日時）
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = route.plan_name
        ? `${route.plan_name}_route_${timestamp}.kml`
        : `route_${timestamp}.kml`;

      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // メモリ解放
      URL.revokeObjectURL(url);

      console.log('KML download completed');
    } catch (error) {
      console.error("Error downloading KML:", error);
      // エラーが発生しても既存機能に影響を与えない
    }
  }

  // ルートデータをCSVとしてダウンロードする関数
  function downloadRouteAsCSV() {
    try {
      if (!route || !route.points || route.points.length === 0) {
        return;
      }

      // CSVヘッダー
      let csvContent = "Point Number,Latitude,Longitude,Comment\n";

      // 各座標をCSV形式で追加
      route.points.forEach((point, index) => {
        if (point.lat != null && point.lng != null) {
          const pointNumber = index + 1;
          const comment = point.comment || '';
          // CSVではダブルクォートで囲む
          csvContent += `${pointNumber},${point.lat},${point.lng},"${comment}"\n`;
        }
      });

      // BOMを追加（ExcelでUTF-8を正しく認識させるため）
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
      const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });

      // ダウンロード用のリンクを作成
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // ファイル名を生成（ルート名 + 日時）
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = route.plan_name
        ? `${route.plan_name}_route_${timestamp}.csv`
        : `route_${timestamp}.csv`;

      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // メモリ解放
      URL.revokeObjectURL(url);

      console.log('CSV download completed');
    } catch (error) {
      console.error("Error downloading CSV:", error);
      // エラーが発生しても既存機能に影響を与えない
    }
  }

  function closeConfirmModal() {
    setConfirmModalShow(false);
    setConfirmTitle(null);
    setConfirmMsg(null);
    setSaveSpinStatus(false);
    setDeleteSpinStatus(false);
  }
  if (plans === null) {
  }
  plans.sort(function (a, b) {return a.plan_name.localeCompare(b.plan_name);})

  return (
    <>
      <Card>
        {/* <Card.Header
          className="titlecustom"
          style={{ color: "#585858", fontSize: "18px" }}
        > */}
        <Accordion.Toggle
          as={Card.Header}
          eventKey="0"
          className="titlecustom"
          style={{ color: "#585858", fontSize: "18px" }}
        >
          Route
        </Accordion.Toggle>
        {/* </Card.Header> */}
        <Accordion.Collapse eventKey="0">
          <Card.Body id="route_part" style={{ minWidth: "350px", padding: "10px", fontSize: "13px" }}>
            <Form style={{ fontSize: "13px" }}>
              <Form.Group controlId="Form.RouteSelector" style={{ marginBottom: "8px" }}>
                {route === undefined ? null : (
                  <Form.Control
                    as="select"
                    onChange={() => setAlertModalShow(true)}
                    ref={refSelectFleets}
                    style={{ fontSize: "13px" }}
                  >
                    {plans.map((plan, key) => (
                      <option value={plan.plan_id} key={key}>
                        {plan.plan_name}
                      </option>
                    ))}
                  </Form.Control>
                )}
                {mode === "fieldTest" ? null : (
                  <ModalbtnCreateNewPlan
                    fleetId={fleetId}
                    vecId={vecId}
                    setConfirmModalShow={setConfirmModalShow}
                    plans={plans}
                    setPlans={setPlans}
                    setConfirmTitle={setConfirmTitle}
                    setConfirmMsg={setConfirmMsg}
                  />
                )}
                {mode === "fieldTest" || route === undefined ? null : (
                  <ModalbtnCopyPlan
                    copiedPlanId={route.plan_id}
                    basePlanName={route.plan_name}
                    plans={plans}
                    setPlans={setPlans}
                    setConfirmModalShow={setConfirmModalShow}
                    setConfirmTitle={setConfirmTitle}
                    setConfirmMsg={setConfirmMsg}
                  />
                )}
                {mode === "fieldTest" || route === undefined ? null : (
                  <>
                    <ModalbtnDiscardEditPlan resetPlan={resetPlan} />
                    <Button
                      size="sm"
                      variant="grey"
                      onClick={() => setDeleteModalShow(true)}
                      style={{ margin: "3px" }}
                      title="delete this plan"
                    >
                      <TrashIcon />
                    </Button>
                  </>
                )}
              </Form.Group>
              {route === undefined ? null : (
                <>
                  <Form.Group controlId="Form.RouteNameTextarea" style={{ marginBottom: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "3px" }}>
                      <Form.Text style={{ fontSize: "12px" }}>Route</Form.Text>
                      <FaCircleInfo
                        style={{ color: "gray", cursor: "pointer", fontSize: "14px" }}
                        title="limits to 250 characters"
                      />
                    </div>
                    <Form.Control
                      as="textarea"
                      ref={plannameRef}
                      onChange={changeName}
                      disabled={mode === "fieldTest"}
                      style={{ fontSize: "13px" }}
                    />
                  </Form.Group>
                  <Form.Group style={{ marginBottom: "8px" }}>
                    <div style={{ display: "flex", gap: "15px" }}>
                      {/* Distance */}
                      <div style={{ flex: 1 }}>
                        <Form.Text style={{ fontSize: "11px" }}>distance</Form.Text>
                        <div>
                          <span
                            style={{
                              color:
                                route.distance > maximumDistanceValueOfSaved
                                  ? "red"
                                  : "black",
                              fontSize: "14px",
                              fontWeight: "500"
                            }}
                          >
                            {route.distance ? route.distance / 1000 : "---"}
                          </span>{" "}
                          <span style={{ fontSize: "13px" }}>km</span>
                        </div>
                      </div>
                      {/* Time */}
                      <div style={{ flex: 1 }}>
                        <Form.Text style={{ fontSize: "11px" }}>time</Form.Text>
                        <div>
                          <span style={{ fontSize: "14px", fontWeight: "500" }}>
                            {route.time ? sec2hhmm(route.time) : "--- min"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                  <Form.Group controlId="Form.RouteCommentTextarea" style={{ marginBottom: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "3px" }}>
                      <Form.Text style={{ fontSize: "12px" }}>Comment</Form.Text>
                      <FaCircleInfo
                        style={{ color: "gray", cursor: "pointer", fontSize: "14px" }}
                        title="limits to 1000 characters"
                      />
                    </div>
                    <Form.Control
                      as="textarea"
                      ref={planCommnetRef}
                      onChange={changeComment}
                      maxLength="1000"
                      disabled={mode === "fieldTest"}
                      style={{ fontSize: "13px" }}
                    />
                  </Form.Group>
                  {mode === "fieldTest" ? null : (
                    <Button
                      size="sm"
                      variant="red"
                      onClick={savePlan}
                      style={{ width: "100%", margin: "3px 0" }}
                    >
                      Save
                      {saveSpinStatus ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                    </Button>
                  )}
                  {/* Download KML/CSV ボタン */}
                  {mode === "fieldTest" ? null : (
                    <div style={{ display: "flex", gap: "8px", margin: "3px 0" }}>
                      <Button
                        size="sm"
                        variant="warning"
                        onClick={downloadRouteAsKML}
                        style={{ flex: 1 }}
                      >
                        KML Download
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={downloadRouteAsCSV}
                        style={{ flex: 1 }}
                      >
                        CSV Download
                      </Button>
                    </div>
                  )}
                  {/* Google Mapリンク表示エリア */}
                  {mode === "fieldTest" || googleMapsLinks.length === 0 ? null : (
                    <div style={{ marginTop: "8px", padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img
                            src={iconGoogleMapsLinks}
                            alt="Google Maps"
                            style={{ width: "18px", height: "18px" }}
                          />
                          <Form.Text style={{ fontWeight: "bold", margin: 0, fontSize: "12px" }}>
                            Google Maps Link{googleMapsLinks.length > 1 ? "s" : ""}
                          </Form.Text>
                          <FaCircleInfo
                            style={{ color: "gray", cursor: "pointer", fontSize: "14px" }}
                            title="Google Mapsの仕様により、開始点+20経由地までの制限があるため、それ以上の経由地がある場合は、Google Mapsへのリンクが分割されます / Due to Google Maps specifications, there is a limit of starting point + 20 waypoints. If there are more waypoints, the links will be split into multiple Google Maps links."
                          />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                          <Button
                            size="sm"
                            variant="success"
                            onClick={downloadLinksAsExcel}
                            style={{ fontSize: "11px", padding: "3px 8px", whiteSpace: "nowrap" }}
                          >
                            Excel Download
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={downloadLinksAsCSV}
                            style={{ fontSize: "11px", padding: "3px 8px", whiteSpace: "nowrap" }}
                          >
                            CSV Download
                          </Button>
                        </div>
                      </div>
                      {/* スクロール可能なリンクリスト領域 */}
                      <div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>
                        {googleMapsLinks.map((link, index) => (
                        <div key={index} style={{ marginBottom: "6px" }}>
                          {googleMapsLinks.length > 1 && (
                            <Form.Text style={{ fontSize: "11px", color: "#666" }}>
                              Route {index + 1} of {googleMapsLinks.length}
                            </Form.Text>
                          )}
                          <div style={{ display: "flex", gap: "4px", marginTop: "3px" }}>
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                flex: 1,
                                padding: "6px",
                                backgroundColor: "#fff",
                                border: "1px solid #ced4da",
                                borderRadius: "3px",
                                fontSize: "11px",
                                color: "#007bff",
                                textDecoration: "none",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block"
                              }}
                            >
                              Open in Google Maps
                            </a>
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              onClick={() => copyToClipboard(link, index)}
                              style={{ minWidth: "50px", fontSize: "11px", padding: "4px 8px" }}
                            >
                              {copiedLinkIndex === index ? "✓" : "Copy"}
                            </Button>
                          </div>
                        </div>
                      ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </Form>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <ModalAlertChangePlan
        alertModalShow={alertModalShow}
        notChangePlan={notChangePlan}
        changePlan={changePlan}
      />
      <ModalAlertDeletePlan
        deleteModalShow={deleteModalShow}
        cancelDeletePlan={cancelDeletePlan}
        deletePlan={deletePlan}
        deleteSpinStatus={deleteSpinStatus}
      />
      <ModalConfirm
        modalTitle={confirmTitle}
        showModal={confirmModalShow}
        closeModal={closeConfirmModal}
        message={confirmMsg}
      />
    </>
  );
}
